import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TablePageInfo } from '../../../models/table_page.model';

@Component({
  selector: 'app-table-pagination',
  templateUrl: './table-pagination.component.html',
  styleUrls: ['./table-pagination.component.css']
})
export class TablePaginationComponent implements OnInit {
  @Input() pageInfo: TablePageInfo;
  @Input() totalRecords: number = 0;
  @Input() loading: boolean = false;
  @Input() showRecordsInfo: boolean = true;
  @Input() containerClass: string = 'px-4 py-2 h-100';
  @Input() borderTop: boolean = true;
  
  @Output() pageChange = new EventEmitter<string>();
  @Output() goToPage = new EventEmitter<number>();
  
  public Math = Math;
  public isPageInputEditing: boolean = false;

  ngOnInit() {
    // Inicializar si no se proporciona pageInfo
    if (!this.pageInfo) {
      this.pageInfo = {
        n_per_page: 15,
        page_number: 1,
        total_pages: 0,
        count_records: 0
      };
    }
  }

  onChangePage(operator: string) {
    this.pageChange.emit(operator);
  }

  onGoToPage(page: number) {
    this.goToPage.emit(page);
  }

  activatePageInputEditing() {
    this.isPageInputEditing = true;
    setTimeout(() => {
      const input = document.querySelector('.page-input-field') as HTMLInputElement;
      if (input) {
        input.focus();
        input.select();
      }
    }, 0);
  }

  deactivatePageInputEditing() {
    this.isPageInputEditing = false;
  }

  onPageInputChange(event: any) {
    const inputValue = parseInt(event.target.value);
    if (!isNaN(inputValue) && inputValue >= 1 && inputValue <= this.pageInfo.total_pages) {
      this.onGoToPage(inputValue);
    } else {
      event.target.value = this.pageInfo.page_number;
    }
    this.deactivatePageInputEditing();
  }

  onPageInputKeyPress(event: any) {
    if (event.key === 'Enter') {
      this.onPageInputChange(event);
    } else if (event.key === 'Escape') {
      event.target.value = this.pageInfo.page_number;
      this.deactivatePageInputEditing();
    }
  }

  onPageInputBlur(event: any) {
    this.onPageInputChange(event);
  }

  shouldShowPagination(): boolean {
    return !this.loading && this.pageInfo && this.pageInfo.total_pages > 1;
  }

  getStartRecord(): number {
    return ((this.pageInfo.page_number - 1) * this.pageInfo.n_per_page) + 1;
  }

  getEndRecord(): number {
    return Math.min(this.pageInfo.page_number * this.pageInfo.n_per_page, this.pageInfo.count_records);
  }
}
